import "moment/locale/it"
import { Col, Row } from "react-bootstrap"
import { statNumberToString } from "../../../../apis/transform/stats"
import { Progress } from "antd"
import cx from "classnames"
import style from "./style.module.scss"

export function PlayerCrosses({ crosses, percentageCrosses }: { crosses: number; percentageCrosses: number }) {
  return (
    <div className={style.playerCrossesContainer}>
      <Row className={cx(style.playerCrossesRow, style.whiteBg)}>
        <dl>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.label}>
            <dt>Cross</dt>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.value}>
            <dd>{statNumberToString(crosses)}</dd>
          </Col>
        </dl>
      </Row>
      <Row className={style.playerCrossesRow}>
        <dl>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.label}>
            <dt>Cross riusciti</dt>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.value}>
            <dd>{statNumberToString(percentageCrosses)}%</dd>
          </Col>
          <Col>
            <Progress
              percent={percentageCrosses}
              size="small"
              showInfo={false}
              strokeLinecap={"square"}
              strokeColor={"#f4c400"}
              trailColor="white"
            />
          </Col>
        </dl>
      </Row>
    </div>
  )
}
